export const SmartidLogin = {
    name: 'SmartIdLogin',
    template: "#smartid-login-template",
    props: ['startAuthenticationUrl'],
    data: function() {
        return {
            idCode: '',
            verificationCode: '',
            errorMessages: '',
            isGenericErrorVisible: false
        }
    },
    methods: {
        startAuthentication: function () {
            let that = this;
            let smartId = new FormData();
            smartId.append('IdCode', that.idCode);

            that.errorMessages = '';
            that.isGenericErrorVisible = false;
            that.verificationCode = '';

            window.estonianIdShared.startAuthenticationPolling(smartId, that, that.startAuthenticationUrl, 'verificationCode');
        }
    }
};

export const MobileidLogin = {
    name: 'MobileIdLogin',
    template: "#mobileid-login-template",
    props: ['startAuthenticationUrl'],
    data: function ()  {
        return {
            email: '',
            phoneNumber: '',
            verificationCode: '',
            errorMessages: '',
            isGenericErrorVisible: false
        }
    },
    methods: {
        startAuthentication: function () {
            let that = this;
            let mobileIdData = new FormData();
            mobileIdData.append('Email', that.email);
            mobileIdData.append('PhoneNumber', that.phoneNumber);

            that.errorMessages = '';
            that.isGenericErrorVisible = false;
            that.verificationCode = '';

            window.estonianIdShared.startAuthenticationPolling(mobileIdData, that, that.startAuthenticationUrl, 'verificationCode');
        }
    }
};
